import React from 'react';
import '../../assets/sass/components/Footer.scss';

const Footer = () => <footer className="grid-container footer-container" />;

export default Footer;
